import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Tab from '../tab/Tab'
import styles from './style/tabs_style.module.scss';


const Tabs = ({ tabs, type, fill, selected, className= '', style = {} }) => {

    const [selectedIndex, setSelectedIndex] = useState()

    useEffect(() => {
        setSelectedIndex(selected)
    }, [selected])

    const onClick = (index, fn) => {
        setSelectedIndex(index)
        fn && fn()
    }

    const _tabs = () => {
        return (
            <div className={`${styles[type+'s']} ${className} ${fill && styles.fill}`}
                 style={style}
            >
                {
                    tabs.map((tab, i) => {
                        return (
                            <Tab key={`tab-${i}`}
                                 className={styles.tab}
                                 onClick={() => onClick(i, tab.onClick)}
                                 selected={selectedIndex === i}
                                 {...(type === 'tab' ? {'style-tab': true} : type === 'chip' ? {'style-chip-s': true} : {'style-selector': true})}
                                 gtmLabel={tab.gtmLabel}
                            >
                                {tab.label}
                            </Tab>
                        )
                    })
                }
            </div>
        )
    }

    return _tabs();
};

Tabs.propTypes = {
    tabs: PropTypes.array.isRequired,
    selected: PropTypes.number,
    className: PropTypes.string,
    style: PropTypes.object,
    type: PropTypes.oneOf(['tab', 'chip', 'selector']),
    fill: PropTypes.bool
}

Tabs.defaultProps = {
    type: 'tab'
}


export default Tabs;
